import React from 'react';

import MenuManagementMenuPreviewContext from 'context/MenuManagementMenuPreviewContext';
import PropTypes from 'prop-types';

import useProvideMenuManagementMenuPreview from 'hooks/useProvideMenuManagementMenuPreview';

export function MenuManagementMenuPreviewProvider({ children }) {
  const menuPreview = useProvideMenuManagementMenuPreview();
  return (
    <MenuManagementMenuPreviewContext.Provider value={menuPreview}>
      {children}
    </MenuManagementMenuPreviewContext.Provider>
  );
}

MenuManagementMenuPreviewProvider.propTypes = {
  children: PropTypes.node,
};

export default MenuManagementMenuPreviewProvider;
